import { create } from "zustand";
import type { FenceState } from "../types/fence";

export const useFenceStore = create<FenceState>((set) => ({
	isFencesModalOpen: false,
	showFencesOnMap: true,
	selectedFence: null,
	drawingMode: null,
	tempCircle: null,
	tempPolygon: [],
	isDraggingCircle: false,
	circleDragStart: null,
	isDataModalOpen: false,
	pendingFenceData: null,
	isEditingFence: null,
	isRedrawingEdit: false,

	openFencesModal: () => set({ isFencesModalOpen: true }),
	closeFencesModal: () =>
		set({
			isFencesModalOpen: false,
			selectedFence: null,
			drawingMode: null,
			tempCircle: null,
			tempPolygon: [],
			isDraggingCircle: false,
			circleDragStart: null,
			isDataModalOpen: false,
			pendingFenceData: null,
			isEditingFence: null,
		}),
	toggleShowFencesOnMap: () =>
		set((state) => ({ showFencesOnMap: !state.showFencesOnMap })),
	setShowFencesOnMap: (show) => set({ showFencesOnMap: show }),
	setSelectedFence: (fence) => set({ selectedFence: fence }),
	startDrawing: (mode) =>
		set({
			drawingMode: mode,
			isEditingFence: null,
			isRedrawingEdit: false,
			tempCircle: null,
			tempPolygon: [],
			isDraggingCircle: false,
			circleDragStart: null,
		}),
	beginFenceEdit: (fence) =>
		set({
			isEditingFence: fence,
			isRedrawingEdit: false,
			drawingMode: fence.type === 1 ? "circle" : "polygon",
			tempCircle: null,
			tempPolygon: [],
			isDraggingCircle: false,
			circleDragStart: null,
		}),
	cancelDrawing: () =>
		set({
			drawingMode: null,
			tempCircle: null,
			tempPolygon: [],
			isDraggingCircle: false,
			circleDragStart: null,
			isEditingFence: null,
			isRedrawingEdit: false,
		}),
	setTempCircle: (circle) => set({ tempCircle: circle }),
	setIsDraggingCircle: (isDragging) => set({ isDraggingCircle: isDragging }),
	setCircleDragStart: (point) => set({ circleDragStart: point }),
	addPolygonPoint: (point) =>
		set((state) => ({ tempPolygon: [...state.tempPolygon, point] })),
	setTempPolygon: (points) => set({ tempPolygon: points }),
	removeLastPolygonPoint: () =>
		set((state) => ({
			tempPolygon: state.tempPolygon.slice(0, -1),
		})),
	clearTempPolygon: () => set({ tempPolygon: [] }),
	resetEditingGeometry: () =>
		set((state) => {
			if (!state.isEditingFence) {
				return {};
			}
			return {
				isRedrawingEdit: true,
				drawingMode: state.isEditingFence.type === 1 ? "circle" : "polygon",
				tempCircle: null,
				tempPolygon: [],
				isDraggingCircle: false,
				circleDragStart: null,
			};
		}),
	clearTempData: () =>
		set({
			tempCircle: null,
			tempPolygon: [],
			drawingMode: null,
			isDraggingCircle: false,
			circleDragStart: null,
			isRedrawingEdit: false,
		}),
	openDataModal: (data) =>
		set((state) => ({
			isDataModalOpen: true,
			pendingFenceData: data,
			drawingMode: null,
			tempCircle: null,
			tempPolygon: [],
			isDraggingCircle: false,
			circleDragStart: null,
			isEditingFence: state.isEditingFence,
			isRedrawingEdit: false,
		})),
	closeDataModal: () =>
		set({
			isDataModalOpen: false,
			pendingFenceData: null,
			isEditingFence: null,
			isRedrawingEdit: false,
		}),
	setEditingFence: (fence) => set({ isEditingFence: fence }),
}));
